export enum ClassLearnType {
  Grade = 1,
  Discipline,
  Class,
  InClass,
  Task,
  Exam,
}
